import SearchHelper from '../../helpers/SearchHelper'
import Utils from '../../utilities/Utils'
import request from './request'

export default class InvoicesController {
  static getInvoices(workspaceId: string, page: number = 1, parameters = {}) {
    return request(`/api/workspaces/${workspaceId}/invoices?page=${page}&${SearchHelper.getQueryString(parameters)}`)
  }

  static requestExport(workspaceId: string, type: 'pdf' | 'ubl', year: number, quarter: number, bookingStatus: 'all' | 'booked' | 'unbooked') {
    return request(`/api/workspaces/${workspaceId}/invoices/export?${Utils.encodeQueryData({ type, year, quarter, booking_status: bookingStatus })}`)
  }
}
